function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".question_mark_svg__cls-1{fill:#f5f8fc}"));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "question_mark_svg__Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "question_mark_svg__Capa_6",
  "data-name": "Capa 6"
}, React.createElement("path", {
  className: "question_mark_svg__cls-1",
  d: "M12.5 0A12.51 12.51 0 000 12.5v11.35A1.15 1.15 0 001.15 25H12.5a12.5 12.5 0 000-25zm10.21 12.5A10.22 10.22 0 0112.5 22.71H2.29V12.5a10.21 10.21 0 1120.41 0z"
}), React.createElement("path", {
  className: "question_mark_svg__cls-1",
  d: "M12.12 16.51a1.48 1.48 0 000 3 1.48 1.48 0 100-3zM12.34 6.73c-2.34 0-3.49 1.46-3.49 2.44A1.14 1.14 0 0010 10.31a1 1 0 00.87-.57A1.38 1.38 0 0112.29 9c.31 0 1.32.07 1.32 1 0 .65-.58 1.09-1.09 1.48l-.34.27A3.25 3.25 0 0011 14.42c0 1 .3 1.31 1.11 1.31 1 0 1.17-.55 1.17-.87a1.94 1.94 0 01.87-2 4.15 4.15 0 002-3.21c-.05-1.7-1.6-2.92-3.81-2.92z"
})));

var SvgQuestionMark = function SvgQuestionMark(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 25 25"
  }, props), _ref, _ref2);
};

export default SvgQuestionMark;